import { render, staticRenderFns } from "./head.vue?vue&type=template&id=95f59f6a&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"
import style0 from "./head.vue?vue&type=style&index=0&id=95f59f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f59f6a",
  null
  
)

export default component.exports